<div class="dropdown-search-table">
  <!-- Label above search input (with title, subtitle, and optional checkbox on same row) -->
  <div class="dropdown-label" *ngIf="searchTitle || subtitle || checkbox">
    <span class="search-title">{{ searchTitle }}</span>
    <span class="search-subtitle">{{ subtitle }}</span>
    <div class="checkbox-group" *ngIf="checkbox">
      <label>
        <input type="checkbox" (change)="onCheckboxChange($event)" />
        <span class="checkbox-description">{{ checkboxDescription }}</span>
      </label>
    </div>
  </div>

  <!-- Search input row with fixed width input and clear button -->
  <div class="search-wrapper">
    <div class="input-wrapper">
      <input
        type="text"
        class="ods-text-input"
        [(ngModel)]="searchText"
        (input)="onSearchChange()"
        placeholder="Search...">
      <img src="assets/images/icons/search.svg" alt="Search Icon" class="search-icon">
    </div>
    <ods-button variant="ghost" *ngIf="searchText" (click)="clearSearch()">
      Clear Search
    </ods-button>
  </div>

  <!-- Dropdown list -->
  <div class="dropdown" *ngIf="dropdownVisible">
    <ul>
      <li *ngFor="let item of filteredItems; trackBy: trackByFn" (click)="selectItem(item)">
        {{ item[dropdownNameField] }}
      </li>
    </ul>
  </div>
</div>

<!-- Phoenix Table displaying the selected item's value -->
<app-phoenix-table
  *ngIf="selectedItem"
  [header]="tableHeader"
  [data]="[selectedItem[dropdownValueField]]"
  [config]="tableConfig"
  [isLoading]="false"
  [showResults]="false">
</app-phoenix-table>

